import { useEffect } from 'react';

import { useRouter } from 'expo-router';

// expo router always handles incoming links it can understand so this provides "burgerking:///noop" functionality
export default function NoopRoute() {
  const router = useRouter();

  useEffect(() => {
    router.back();
  }, []);

  return null;
}
